module.exports = __webpack_public_path__ + "static/language-1-a9a030bd32c43bf2316bb5f5fcb54332.jpg";